<template>
  <v-fade-transition>
    <wgu-module-card v-bind="$attrs" :moduleName="moduleName" :icon="icon" class="card" :width=winwidth
      :height=winheight>

      <v-card-text class="heightRest text-lg-body-1 text-body-2">
        <div>
          <h1>Barrierefreiheitserklärung</h1>
          <p>
            Die Stadtentwässerungsbetriebe Köln, AöR bemühen sich, ihre Internetseiten und mobilen Anwendungen im Einklang mit dem Behindertengleichstellungsgesetz Nordrhein-Westfalen (BGG NRW)
            und der Barrierefreie-Informationstechnik-Verordnung (BITV 2.0) barrierefrei zugänglich zu machen.<br/>
            Diese Erklärung gilt für die Website: https://hw-karten.de

          </p>

          <h2>Stand der Vereinbarkeit mit den Anforderungen</h2>
          <p>
            Die Website ist mit dem
          </p>
            <ul>
              <li>Behindertengleichstellungsgesetz Nordrhein-Westfalen (BGG NRW) und der Barrierefreie-Informationstechnik-Verordnung Nordrhein-Westfalen (BITV NRW)</li>
            </ul>
          <p>
            größtenteils nicht vereinbar.<br>
            Die Unvereinbarkeiten und/oder Ausnahmen sind nachfolgend aufgeführt.
          </p>

          <h2>Nicht barrierefreie Inhalte</h2>
          <p>
            Diese Website basiert auf dynamisch generierten, nutzerseitig konfigurierbaren Karteninhalten, die nicht der Navigation dienen.
            Ohne diese Karteninhalte ist eine korrekte und fassbare Beschreibung der Aussagen nicht möglich.
            Eine alternative Darstellung der teilweise sehr komplexen Karteninhalte stellt eine unverhältnismäßige Belastung dar.
          </p>

          <h2>Erstellung dieser Erklärung zur Barrierefreiheit</h2>
          <p>
            Diese Erklärung wurde am 25.06.2025 erstellt und zuletzt am 28.06.2025 überprüft. Sie beruht auf einer Selbstbewertung, die anhand der folgenden Standards durchgeführt wurde:
          </p>
            <ul>
              <li>Barrierefreie-Informationstechnik-Verordnung (BITV 2.0),</li>
              <li>Europäischen Norm EN 301 549,</li>
              <li>Web Content Accessibility Guidelines (WCAG) 2.2, Konformitätsstufe AA</li>
            </ul>
          <p>
            Die Überprüfung dieser Erklärung erfolgt mindestens jährlich.
          </p>

          <h2>Feedback und Kontaktmöglichkeiten</h2>
          <p>
            Über die nachfolgenden Kontaktdaten können Sie mit uns zur Barrierefreiheit in Verbindung treten. Insbesondere können Sie uns Fragen stellen, etwaige Mängel mitteilen und Informationen über die von der Anwendung der einschlägigen Gesetze ausgenommenen Inhalte einholen.
          </p>
          <p>
            Stadtentwässerungsbetriebe Köln, AöR<br/>
            Ostmerheimer Straße 555<br/>
            51109 Köln<br/>
            Telefon: 0221 221-26868<br/>
            E-Mail: <a href="mailto:steb@steb-koeln.de">steb@steb-koeln.de</a><br/>
            Kontaktformular: <a href="https://steb-koeln.de/service/kontakt/Kontaktseite.jsp#section_117332">https://steb-koeln.de/service/kontakt/Kontaktseite.jsp#section_117332</a><br/>

          </p>

          <h2>Durchsetzungsverfahren</h2>
          <p>
            Wenn auch nach Ihrem Feedback an den oben genannten Kontakt keine zufriedenstellende Lösung gefunden wurde, können Sie sich an die Ombudsstelle für barrierefreie Informationstechnik des Landes Nordrhein-Westfalen wenden.
          </p>
          <p>
            Ombudsstelle Barrierefreie Informationstechnik NRW bei der Landesbeauftragten für Menschen mit Behinderung<br/>
            Fürstenwall 25<br/>
            40219 Düsseldorf <br/>
            <br/>
            E-Mail: <a href="mailto:ombudsstelle-barrierefreie-it@mags.nrw.de">ombudsstelle-barrierefreie-it@mags.nrw.de</a><br/>
            Website: <a href="https://www.mags.nrw/ombudsstelle-barrierefreie-informationstechnik">www.mags.nrw/ombudsstelle-barrierefreie-informationstechnik</a><br/>
          </p>

          <p>&nbsp;</p>
      </div>
      </v-card-text>

    </wgu-module-card>
  </v-fade-transition>
</template>

<script>
// the module card is a the template for a typical Wegue module
import ModuleCard from '../../../src/components/modulecore/ModuleCard';

export default {
  name: 'wgu-barrierefreiheit',
  // make sure to register the 'Mapable' mixin
  components: {
    'wgu-module-card': ModuleCard
  },
  created () {
  },
  props: {
    icon: { type: String, required: false, default: 'star' }
  },
  mounted () {
    // console.log(this.$parent.$el.offsetHeight);
  },
  computed: {
    winwidth () {
      // console.log(this.$vuetify.breakpoint.name);
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '80%';
        case 'sm': return 540;
        case 'md': return 600;
        case 'lg': return 700;
        case 'xl': return 800;
      }
      return 500;
    },
    winheight () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 400
        case 'sm': return 450
        case 'md': return 530
        case 'lg': return 600
        case 'xl': return 800
      }
      return 500;
    }
  },
  // here we define variables that are used in the HTML above
  data () {
    return {
      moduleName: 'wgu-barrierefreiheit'
    };
  },
  methods: {
    /**
     * This function is called once the map is bound to the application
     */
  }
};
</script>

<!-- Here we do the styling of our module -->
<style scoped>

.card {
  overflow: auto;
  left: 50% !important;
  right: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%);  /* zentriert Fenster, bei kleinen Bildschirmen dann*/
  /*
  height: 90%;
  width: 90%;
  */
  max-width: 90%;
  max-height: 90%;
  min-width: 250px;
  min-height: 250px;
  z-index: 55 !important;

}

.v-card > :last-child {
  overflow: auto;
  height: calc(100% - 70px);
}

h1 {
  font-size: 1.5em;
  line-height: 2rem;
  margin-bottom: 0.2em;
  color: #00508c;
}

h2 {
  font-size: 1.2em;
  margin-bottom: 0.2em;
  color: #00508c;
}

h3 {
  font-size: 1.1em;
  margin-bottom: 0.2em;
  color: #00508c;
}

p {
  font-size: 1em;
  line-height: 1.5rem;
  margin-top: 0.75em;
}

a {
    color: #007bC7 !important;
}

</style>
